<template>
    <div class="c-cekajici-resene__info">
        <div class="c-widget">
            <div class="c-widget__item" >{{translate('Page1.text0.' + day)}}<br>{{date}}</div>
            <div class="c-widget__item c-widget__item--clock">
                <div class="c-widget__time-1">{{time}}</div>
                <div>
                    <input type="text"
                        class="c-widget__time-2"
                        v-model="simulationProgress"
                        pattern="([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}"
                        @change="setProgress"
                        :disabled="disabledTimeEdit"
                    >
                </div>
                <div class="c-widget__control">
                    <simControls @isPaused="toggleTimeEdit"></simControls>
                </div>
            </div>
            <div class="c-widget__item">{{translate('Page1.text1')}}<br><span >{{vyjezdu}}</span></div>
            <editableToggle v-if="isEditableToggleVisible" @on-scenario-editable="onScenarioEditable"></editableToggle>
        </div>

    </div>
</template>

<script>
    const DEFAULT_TIME =  '';
    const WEEK_DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    
    import { mapActions } from 'vuex';
    import simControls from '@/components/simControls.vue';
    import editableToggle from '@/components/editableToggle.vue';
    import dateFormat from '../utils/dateFormat';




    export default {
        name: "timerBar",
        data: function() {
            return {
                progressString: 0,
                progresChangeRegistered: false,
                isEditableToggleVisible: false,
                disabledTimeEdit: true     // controls if scenario time is editable -> editable only if paused
            }
        },
        components: {
            simControls,
            editableToggle
        },
        methods: {
            async setProgress() {
                const split = this.simulationProgress.split(':');
                const progress = 1000*(Number(split[2])+Number(split[1])*60+Number(split[0])*3600);
                try {
                    await this.$store.dispatch('callApi', {
                        name: 'setTime',
                        payload: {progress}
                    });
                    this.progresChangeRegistered = false;
                    //this.$eventHub.$emit('openMessageController', 'success' , `Simulace se spustila`);
                } catch (e) {
                    this.$eventHub.$emit('openMessageController', 'error' , e);
                }
            },
            onScenarioEditable () {
                this.$emit('on-scenario-editable');
            },

            // callback method for "isPaused" event
            toggleTimeEdit (simulationPaused) {
                if(simulationPaused === true){
                    this.disabledTimeEdit = false;
                    console.log("enabled simulation time editing");
                }
                else if(simulationPaused === false){
                    this.disabledTimeEdit = true;
                    console.log("disabled simulation time editing");
                }
            },
            // checks stored simulation state and enables/disables scenario time editing based on simulation state
            mountedToggleTimeEdit(){
                if(this.$store.state.simulation.properties.state === 'play'){
                    this.disabledTimeEdit = true;
                    console.log("disabled simulation time editing");
                }
                else if(this.$store.state.simulation.properties.state === 'pause'){
                    this.disabledTimeEdit = false;
                    console.log("enabled simulation time editing");
                }
            },

            /**
             *
             * @returns {Promise<Array>}
             */
            async getPermissions(){
                return this.$store.dispatch('callApi', {
                    name: 'getPermissions'
                });
            },
            ...mapActions(['authorizeCMD'])

        },
        async mounted() {
            const permissions = await this.getPermissions();
            console.log('requesting user access to creator switch: ', + new Date());
            const response = await this.authorizeCMD({cmd: ('addEventScenario')});
            console.log('response received for user access to creator switch: ', + new Date());
            console.log({
                'this.$store.state.auth.user.isAdmin': this.$store.state.auth.user.isAdmin,
                'response.authorizeCMD': response.authorizeCMD,
                'permissions.includes(\'edit\')': permissions.includes('edit'),
                'this.$store.state.auth.user.creator': this.$store.state.auth.user.creator
            });
            this.isEditableToggleVisible = this.$store.state.auth.user.isAdmin || (permissions.includes('edit') && response.authorizeCMD && this.$store.state.auth.user.creator);

            this.mountedToggleTimeEdit();
        },
        computed:{
            vyjezdu(){
                let vyjezdu = 0;
                for(let list of ['waitingEvents', 'assignedEvents']) try {
                    const lists = this.$store.state.simulation.lists;
                    vyjezdu += lists[list].length
                    // eslint-disable-next-line
                } catch(e) { }
                return vyjezdu
            },
            simulationProgress: {
                get() {
                    let progress;
                    if(this.progresChangeRegistered){
                        return this.progressString;
                    } else {
                        progress = this.$store.state.time.progress;
                    }
                    try{
                        return dateFormat.getHMS(progress);
                    } catch (e){
                        return DEFAULT_TIME;
                    }
                },
                set(val){
                    this.progressString = val;
                    this.progresChangeRegistered = true;
                }
            },
            day(){
                return WEEK_DAYS[this.virtualTime.getDay()];
            },
            date(){
                const virtualTime = this.virtualTime;
                return `${virtualTime.getDate()}.${virtualTime.getMonth()+1}.${virtualTime.getFullYear()}`;
            },
            virtualTime(){ 
                return new Date(this.$store.state.time.time);
            },
            time(){
                return this.virtualTime.toTimeString().substring(0, 8);
            },
        },


    }
</script>

<style scoped>
    input {
        border: 0;
        box-shadow: none;
    }

    input:-moz-placeholder,
    input:focus {
        box-shadow: none !important;
    }

    input:invalid {
        box-shadow: none;
    }
</style>
